import React, { useState } from 'react';
import { ExpandMore } from '@material-ui/icons';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import './Blog.css';

const Techaccordion = (props) => {
  const [expandedPanel, setExpandedPanel] = useState(false);

  const handleAccordionChange2 = (panel) => (event, isExpanded) => {
    console.log({ event, isExpanded });
    setExpandedPanel(isExpanded ? panel : false);
  };

  const handleAccordionChange = (panel) => {
    setExpandedPanel(panel);
  };

  return (
    <>
      <div className='accordian' onMouseLeave={() => { handleAccordionChange("") }}>
        <Accordion expanded={expandedPanel === 'panel1'} onChange={handleAccordionChange2('panel1')} onMouseOver={() => handleAccordionChange('panel1')} style={{ width: '100%', borderRadius: '30px 50px 15px', marginBottom: '10px', fontWeight: '700', color: 'black' }}>
          <span>
            <AccordionSummary style={{ border: '3px solid #3ec5ba', borderRadius: '30px 50px 15px', fontSize: '20px', paddingLeft: '30%' }} expandIcon={<ExpandMore />}>
              {props.title}
            </AccordionSummary>
          </span>
          <AccordionDetails style={{ textAlign: 'center' }}>
            <p>{props.body}</p>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
}

export default Techaccordion;